
import React from 'react';
import { Dialog, DialogTitle, DialogContent, IconButton, Grid, TextField } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import AgyleButton from '../../ui/buttons/agyleButton';
import SmartViewStep from './SmartViewStep';

const CreateSmartViewDialog = ({
    open,
    onClose,
    view,
    onUpdateName,
    onSetTest,
    onSetHistory,
    onSetView,
    onDeleteStep,
    onAddStep,
    onSave,
    displayImagePref,
    viewDisplay,
    filterDictType,
    onSetDefault,
    onResetDefault,
    isDefault,
    onOpenDisplayDialog, copyFirstStepTest
}) => {

    return (
        <Dialog width={"xl"} maxWidth={'xl'} fullWidth open={open} onClose={onClose}>
            <DialogTitle>
                Create New Smart View
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                ><CloseIcon /></IconButton>
            </DialogTitle>
            <DialogContent>
                <div style={{ borderBottom: "1px solid #626466", padding: 20 }} key={-1 + "SV"}>
                    <Grid container spacing={1} justifyContent={"space-between"}>
                        <Grid item xs={11}>
                            <TextField
                                value={view.name}
                                onChange={(e) => onUpdateName(e.target.value)}
                                label={"Name"}
                                fullWidth
                                variant="outlined"
                            />
                        </Grid>

                        {view.steps?.map((step, index) => {
                            return <SmartViewStep
                                key={index}
                                step={step}
                                index={index}
                                options={filterDictType(view)}
                                displayImagePref={displayImagePref}
                                viewDisplay={viewDisplay}
                                onSetTest={(val) => onSetTest(index, val)}
                                onSetHistory={(val) => onSetHistory(index, val)}
                                onSetView={(test, val) => onSetView(test, val)}
                                onDelete={() => onDeleteStep(index)}
                                onSetDefault={(opt) => onSetDefault(opt, view.id)}
                                onResetDefault={(opt) => onResetDefault(opt, view.id)}
                                isDefault={(opt) => isDefault(opt, view.id)}
                                onOpenDisplayDialog={onOpenDisplayDialog}
                            />
                        })}
                        <Grid item xs={10} display={"inline-flex"} justifyContent={"start"}>
                            <AgyleButton
                                size="small"
                                onClick={onAddStep}
                                style={{ borderRadius: 20 }}
                            >
                                Add Tab
                            </AgyleButton>
                            {view.steps[0]?.test?.length > 0 && <AgyleButton
                                size="small"
                                onClick={copyFirstStepTest}
                                style={{ borderRadius: 20 }}
                            >
                                Copy "Available in" to Tabs
                            </AgyleButton> }
                        </Grid>
                        <Grid item xs={1} sx={{ display: "flex", justifyContent: "flex-end" }}>
                            <AgyleButton
                                size="small"
                                color="primary"
                                onClick={onSave}
                                style={{ borderRadius: 20 }}
                            >
                                Save
                            </AgyleButton>
                        </Grid>
                        <Grid item xs={1} />
                    </Grid>
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default CreateSmartViewDialog;
